export default "<app-rest-password-layout [operation]=\"resetPasswordConstantes.operations.activate_user\"></app-rest-password-layout>\r\n";